module.exports = __webpack_public_path__ + "img/prime.70860730.svg";